import { inject, Pipe, PipeTransform } from '@angular/core';

import { DocumentsService } from '@senet-id/core/services';
import { EDocumentStatus, EDocumentUser, IDocumentForSign, IDocumentVersion } from '@senet-uiverse/common';
import { LanguageCode } from '@senet-uiverse/i18n';

@Pipe({
  name: 'senetDocuments',
})
export class SenetDocumentsPipe implements PipeTransform {
  private documentsService = inject(DocumentsService);

  transform(
    documents: IDocumentVersion[],
    userGroup: EDocumentUser | null,
    currentLang: string,
    orgLang: LanguageCode = LanguageCode.en,
  ): IDocumentForSign[] {
    if (!documents?.length) return [];

    if (!userGroup) {
      userGroup = EDocumentUser.Gamer;
    }

    return documents
      .filter((document) => document.userGroup === userGroup && document.status === EDocumentStatus.Published)
      .map((document) => this.documentsService.mapDocumentForSign(document, currentLang as LanguageCode, orgLang));
  }
}
